import {createSelector} from "@reduxjs/toolkit";
import {partnerDetailsSelector, partnerStatusSelector} from "./partnersSlice";
import {isEmpty} from "es-toolkit/compat";

export const selectPartnersDetails = createSelector([partnerDetailsSelector], partnersDetails =>
  !isEmpty(partnersDetails) ? Object.values(partnersDetails || {}) : {},
);

export const selectPartnersStatus = createSelector([partnerStatusSelector], status => status);

export const selectPartnersShowHcReports = createSelector([partnerDetailsSelector], partnersDetails => {
  return partnersDetails?.showHcReports == 1 || false;
});
